// extracted by mini-css-extract-plugin
export default {"thumbnailCard":"ThumbnailCard_thumbnailCard__Z+PT5","content":"ThumbnailCard_content__d1quV","title":"ThumbnailCard_title__QOR0g","icon":"ThumbnailCard_icon__kg9ed"};